import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Modal,
  FormHelperText,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
  Select,
  CircularProgress,
} from "@mui/material";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
} from "../../../../../constants/colors";
import CloseIcon from "@mui/icons-material/Close";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import {
  getVoiceAgentPhoneNumberForCallingAgent,
  requestACallFromVoiceAgent,
} from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import GetCountryFlagByName from "../../../settingBar/VideoGenSettings/GetCountryFlagByName";
import { countryDatas } from "../../../../../constants/countryList";

 const userEmail = localStorage.getItem("userEmail");

const VoiceCallOptionModal = ({ activeUserObject, setActiveUserObject }) => {
  const {
    showVoiceCallModal,
    setShowVoiceCallModal,
    voiceAgentsAllPhoneNumber,
    setVoiceAgentsAllPhoneNumber,
  } = useWorkspace();
  const theme = localStorage.getItem("theme");
  const userEmail = localStorage.getItem("userEmail");
  const [toastopen, setToastopen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [allFilterCountry, setAllFilterCountry] = useState(countryDatas);
  const [loading, setLoading] = useState(null);
  const [searchCountry, setSearchCountry] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(
          countryDatas.find((country) => country.name === "Canada")
        );

  const handleCountryCodeChange = (country) => {
    // console.log("Country", country)
    setSelectedCountry(country);
  };

  const handleCloseVoiceCallModal = () => {
    setShowVoiceCallModal(false);
    setPhoneNumber("")
  };

  const handleToastClose = () => {
    setToastopen(false);
  };

  const getAllPhoneNumber = async () => {
    try {
      const res = await getVoiceAgentPhoneNumberForCallingAgent();
      const allPhoneNumber = await res.json();
      // console.log("allPhoneNumberForVoiceAgent", allPhoneNumber)
      if (allPhoneNumber?.status) {
        setVoiceAgentsAllPhoneNumber(allPhoneNumber?.data);
      } else {
        setToastopen(true);
        setContent(allPhoneNumber?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  useEffect(() => {
    if (!voiceAgentsAllPhoneNumber) {
      getAllPhoneNumber();
    }
  }, []);

  const isValidPhone = (phone) => {
  const cleaned = phone.replace(/[\s\-().]/g, ''); // Remove spaces, dashes, parentheses, etc.
  return /^\+?[1-9]\d{1,14}$/.test(cleaned); // E.164 format: optional +, 1–15 digits, cannot start with 0
};

  const handleCallNowButtonClick = async (e) => {
    if(phoneNumber == ""){
      setToastopen(true);
      setContent("Please Enter the Number");
      setIconType("error");
      return
    }
    if(!isValidPhone(phoneNumber)){
      setToastopen(true);
      setContent("Please Enter Valid Phone Number");
      setIconType("error");
      return
    }
    setLoading(true)
    const newObj = {
      voice_agent_id: activeUserObject.voice_agent_id,
      phone_number: `+1${phoneNumber}`,
    };
    try {
      const res = await requestACallFromVoiceAgent(newObj);
      const response = await res.json();
      if (response.status) {
        setToastopen(true);
        setContent(response?.message);
        setIconType("success");
        setPhoneNumber("");
        setActiveUserObject(null);
      } else {
        setToastopen(true);
        setContent(response?.message);
        setIconType("error");
      }
    } catch (error) {
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }finally{
      setShowVoiceCallModal(false)
      setLoading(false)
      setPhoneNumber("")
    }
  };

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCountry(searchTerm);
    const filteredCountries = countryDatas.filter((country) =>
      country.name.toLowerCase().includes(searchTerm)
    );
    setAllFilterCountry(filteredCountries);
  };

  return (
    <div>
      <Modal
        open={showVoiceCallModal}
        onClose={handleCloseVoiceCallModal}
        aria-labelledby="audio-settings-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "480px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
          }}
        >
          <Typography
            id="audio-settings-title"
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "68px",
              // mb: 2,
              borderBottom: `1px solid ${
                theme === "dark" ? "rgba(255, 255, 255, 0.20)" : ""
              }`,
              padding: "20px",
              font: "Inter",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            Phone call
            <IconButton
              aria-label="close"
              onClick={handleCloseVoiceCallModal}
              sx={{
                // color: (theme) => theme.palette.grey[500],
                color: "#FFFFFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <Box sx={{ padding: "20px" }}>
            <Box
              sx={{
                borderRadius: "8px",
                padding: "20px",
              }}
            >
              <TextField
                                          type="text"
                                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                           onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/\D/g, '');
                                                 setPhoneNumber(onlyNums);
                                                }}
                                          value={phoneNumber}
                                          label="Phone number*"
                                          variant="outlined"
                                          placeholder="Enter user phone number"
                                          InputProps={{
                                              startAdornment: (
                                              <InputAdornment position="start" sx={{ padding: "0px" }}>
                                                  <Select
                                                  value={selectedCountry?.id || ''}
                                                  variant="standard"
                                                  style={{ width: '80px', height: "40px", padding: "0px" }}
                                                  renderValue={(selectedId) => {
                                                      const country = countryDatas.find(c => c.id === selectedId);
                                                      return (
                                                      <Box sx={{ display: "flex", flexDirection: "row", columnGap: "10px", alignItems: "center", textAlign: "center" }}>
                                                          <GetCountryFlagByName countryName={country?.name} />
                                                          <p style={{ margin: "0px", color: "rgba(255, 255, 255, 0.80)" }}>{country?.mobileCode}</p>
                                                      </Box>
                                                      );
                                                  }}
                                                  sx={{
                                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                      },
                                                      '&:hover:not(.Mui-disabled):before': {
                                                      border: 'none',
                                                      },
                                                      '&::before': {
                                                      borderBottom: 'none',
                                                      },
                                                      '&::after': {
                                                      borderBottom: 'none',
                                                      },
                                                      color: "rgba(255, 255, 255, 0.80)",
                                                      '& .MuiSvgIcon-root': {
                                                      color: '#CAC4D0', // Dropdown icon color
                                                      },
                                                    }}
                                                    MenuProps={{
                                                      PaperProps: {
                                                        sx: {
                                                          backgroundColor: '#282D51',
                                                          color: 'white',
                                                          // Add other custom styles here
                                                        },
                                                      },
                                                    }}
                                                  SelectProps={{
                                                      MenuProps: {
                                                      PaperProps: {
                                                          sx: {
                                                          bgcolor: '#282D51',
                                                          padding: "0px",
                                                          '& .MuiMenuItem-root.Mui-selected': {
                                                              bgcolor: '#282D51',
                                                              color: 'white',
                                                              '&:hover': {
                                                              bgcolor: '#393F69',
                                                              },
                                                          },
                                                          },
                                                      },
                                                      onClose: (event) => {
                                                          if (event?.target?.id === "search-country-input") {
                                                          event.stopPropagation();
                                                          }
                                                      }
                                                      },
                                                  }}
                                                  >
                                                  <Box sx={{ border: "", height: "200px", width: "200px", overflowX: "hidden", overflowY: "scroll", color: "#282D51", bgcolor: "#282D51", padding: "0px", scrollbarWidth: "none", "&::-webkit-scrollbar": {display: "none" } }}>
                                                    {/*  <Box sx={{ p: 1, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                                                      <Input
                                                          value={searchCountry}
                                                          onChange={handleSearch}
                                                          placeholder="Search country"
                                                          onMouseDown={(e) => e.stopPropagation()}
                                                          onClick={(e) => e.stopPropagation()}
                                                          startAdornment={
                                                          <InputAdornment position="start">
                                                              <SearchIcon sx={{ color: "rgba(255,255,255,0.7)" }} />
                                                          </InputAdornment>
                                                          }
                                                          sx={{
                                                          color: "white",
                                                          '&:before, &:after': { borderBottom: 'none' },
                                                          '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                                                          }}
                                                          disableUnderline={false}
                                                      />
                                                      </Box> */}
                                                      {allFilterCountry.map((country) => (
                                                      <MenuItem
                                                          onClick={() => handleCountryCodeChange(country)}
                                                          key={country?.id}
                                                          value={country}
                                                          sx={{
                                                          // bgcolor: country?.id === selectedCountry?.id ? "#373E6D" : '#282D51',
                                                          marginTop: '-8px',
                                                          marginBottom: '-8px',
                                                          width: '200px',
                                                          height: '56px',
                                                          '&:hover': {
                                                              bgcolor: '#393F69'
                                                          },
                                                          "&.Mui-selected": {
                                                              backgroundColor: "#373E6D !important",
                                                              color: "white",
                                                          },
                                                          }}
                                                      >
                                                          <Box sx={{ display: 'flex' }}>
                                                          <Box sx={{
                                                              display: 'flex',
                                                              flexDirection: "row",
                                                              width: '24px',
                                                              height: '24px',
                                                              marginRight: '12px',
                                                              columnGap: "10px"
                                                          }}>
                                                              <GetCountryFlagByName countryName={country?.name} />
                                                              <Typography sx={{
                                                              display: 'block',
                                                              color: "white",
                                                              fontFamily: 'Inter',
                                                              fontSize: '14px',
                                                              textAlign: 'left',
                                                              opacity: '80%'
                                                              }}>{country.name} </Typography>
                                                              <Typography component='span'
                                                              sx={{
                                                                  color: "white",
                                                                  fontFamily: 'Inter',
                                                                  fontSize: '14px',
                                                                  textAlign: 'left',
                                                                  opacity: '80%',
                                                                  marginLeft: '5px'
                                                              }}>{country.mobileCode}</Typography>
                                                          </Box>
                                                          </Box>
                                                      </MenuItem>
                                                      ))}
                                                  </Box>
                                                  </Select>
                                              </InputAdornment>
                                              )
                                          }}
                                          sx={{
                                              width: "100%",
                                              maxWidth: "100%",
                                              height: "48px",
                                              color: "#FFFFFF",
                                              // backgroundColor: "#171A2D",
                                              borderRadius: "8px",
                                              marginBottom:"40px",
                                              // boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                              '& .MuiInputLabel-root': {
                                              color: 'rgba(255, 255, 255, 0.80)', // Label text color
                                              fontFamily: 'Inter',
                                              fontSize: '16px',
                                              fontWeight: 400,
                                              },
                                              '& .MuiOutlinedInput-root': {
                                              '& input': {
                                                  color: "white", // Ensures input text remains white
                                                  fontFamily: 'Inter',
                                                  fontSize: '16px',
                                                  fontWeight: 400,
                                                  cursor: "text", // Ensures cursor appears in the input field
                                              },
                                              '& input::placeholder': {
                                                  color: "rgba(255, 255, 255, 0.80)",
                                                  opacity: 1,
                                              },
                                              '& fieldset': {
                                                  border: "1px solid rgba(255, 255, 255, 0.40)", // Default border color
                                                  borderRadius: "8px",
                                              },
                                              '&:hover fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.40)", // No change on hover
                                              },
                                              '&.Mui-focused fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.80)", // Border color when focused
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 0.80)', // Keeps the label color consistent
                                              }
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 1)', // Change to any color you want
                                              },
                                          }}  
                                      />


              

              <Button disabled={loading}
                variant="contained"
                onClick={() => handleCallNowButtonClick()}
                sx={{
                  backgroundColor:
                    theme === "dark" ? button_bg_color_for_New_Project : "",
                  "&:hover": {
                    backgroundColor: "#FFD9AA",
                  },
                  color: "#17182C",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  width: "100%",
                   '&:disabled': {
                                backgroundColor: button_bg_color_for_New_Project
                              }
                }}
              >
              { loading ?  <CircularProgress sx={{width:"16px", height:"16px", color:"#17182C"}}/>  : "Call now"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <CommonToast
        open={toastopen}
        onClose={handleToastClose}
        content={content}
        iconType={iconType}
        bgColor={"#282D51"}
      />
    </div>
  );
};

export default VoiceCallOptionModal;
